import { render } from "./PayBalanceButton.vue?vue&type=template&id=fa6681a8"
import script from "./PayBalanceButton.vue?vue&type=script&lang=js"
export * from "./PayBalanceButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__